export enum VehicleCondition {
    DAMAGED = 'DAMAGED',
    NOT_DAMAGED = 'NOT_DAMAGED'
}
